<template>
    <div>
        <h4>Scheduled Hours</h4>
        <v-form>
            <v-container>
                <v-row>
                    <v-col
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateStart"
                                    label="Date Start"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateStart"
                                @input="menu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    label="Date End"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateEnd"
                                @input="menu2 = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="6"
                    >
                        <v-select
                            v-model="program"
                            :items="units"
                            item-text="Name"
                            item-value="_id"
                            label="Programs"
                            dense
                            multiple
                            outlined
                            clearable
                            @change="programChange"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-text-field 
                                            v-model="searchTerm" 
                                            placeholder="Search" 
                                            @input="searchUnits"
                                            clearable
                                        ></v-text-field>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                                <v-list-item
                                    ripple
                                    @mousedown.prevent
                                    @click="toggle"
                                >
                                    <v-list-item-action>
                                        <v-icon :color="program.length > 0 ? 'indigo darken-4' : ''">
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class=""></v-divider>
                                <v-list>
                                    <v-list-group
                                        prepend-icon=""
                                    >
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="'Select By State'"></v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <v-list-item
                                            ripple
                                            @mousedown.prevent
                                            @click="toggleUtahPrograms"
                                        >
                                            <v-list-item-action>
                                                <v-icon :color="utahPrograms.length > 0 ? 'indigo darken-4' : ''">
                                                    {{ filterUtahIcon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="'Utah Programs'"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item
                                            ripple
                                            @mousedown.prevent
                                            @click="toggleNevadaPrograms"
                                        >
                                            <v-list-item-action>
                                                <v-icon :color="nevadaPrograms.length > 0 ? 'indigo darken-4' : ''">
                                                    {{ filterNevadaIcon}}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="'Nevada Programs'"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-group>
                                </v-list>
                                <v-divider class="mb-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.Name }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="grey--text text-caption"
                                >
                                    (+{{ program.length - 2 }} others)
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="6"
                    >
                        <v-select
                            v-model="position"
                            :items="droles"
                            label="Positions"
                            dense
                            outlined
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="6"
                    >
                        <v-select
                            v-model="employee"
                            :items="employees"
                            label="Employees"
                            item-text="Name"
                            item-value="_id"
                            dense
                            outlined
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="6"
                    >
                        <v-btn color="success" @click="getScheduleStaff()">
                            Apply
                        </v-btn>
                        <!--
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="downloadPayroll()">
                          Download
                        </v-btn>
                        -->
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="schedules"
                    :options.sync="options"
                    :server-items-length="totalData"
                    class="elevation-1"
                    :loading="isLoadingSchedule"
                    loading-text="Loading... Please wait"
                >
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import axios from 'axios';
import moment from "moment";


import {mapGetters, mapState, mapMutations} from "vuex";
import {setUserTz} from "../../../../utils/timezone";

const url = require("../../../client_config/config").url;

export default {


    data: () => ({
        menu: false,
        menu2: false,
        headers: [
            {
                text: 'Employee',
                align: 'start',
                //sortable: false,
                value: 'EmployeeName',
            },
            {text: 'Position', value: 'position'},
            {text: 'Program', value: 'program'},
            {text: 'Client', value: 'ClientName'},
            {text: 'Scheduled Start', value: 'StartDate'},
            {text: 'Scheduled End', value: 'EndDate'},
            {text: "Total", value: 'TotalTime'},
        ],
        units: [],
        unitsCopy: [],
        employees: [],
        state: localStorage.getItem('userState'),
        employee: "",
        position: "",
        program: [],
        utahPrograms: [],
        nevadaPrograms: [],
        schedules: [],
        radioGroup: 0,
        SplitOvernight: false,
        editedIndex: -1,
        editedItem: {
            id: 0,
            cost: '',
        },
        defaultItem: {
            id: 0,
            cost: '',
        },
        searchTerm: "",
        selectedUnits: [],
        options: {},
        totalData: 0,
        isLoadingSchedule: false
    }),

    created() {
        this.getUnits();
        this.getEmployees();
    },

    computed: {

        ...mapState({
            droles: 'userRoles',
        }),

        ...mapGetters({
            getUserTimezone: "timezones/getUserTimezone",
            getDefaultTz: "timezones/getDefaultTz",
        }),

        userTimezone() {
            const data = {
                userTimezone: this.getUserTimezone,
                defaultTz: this.getDefaultTz,
            };
            return setUserTz(data);
        },

        filteredEmployee() {
            return this.employees.filter(user => user.Role === this.position && user.Program.includes(this.program))
        },

        dateStart: {
            get() {
                return this.$store.state.payroll.dateStart;
            },
            set(val) {
                this.setDateStart(val);
            }
        },

        dateEnd: {
            get() {
                return this.$store.state.payroll.dateEnd;
            },
            set(val) {
                this.setDateEnd(val);
            }
        },

        likesAllUnits() {
            return this.program.length === this.units.length
        },

        likesSomeUnits() {
            return this.program.length > 0 && !this.likesAllUnits
        },

        icon() {
            if (this.likesAllUnits) return 'mdi-close-box'
            if (this.likesSomeUnits) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },

        /*--------------------- Select All Utah programs -----------------*/
        selectedAllUtahPrograms() {
            let sum = 0
            
            this.units.forEach(item => {
                return item.State == "Utah" ? sum++ : sum;
            })
            
            return this.program.length === sum
        },
        filterUtahIcon() {
            if (this.selectedAllUtahPrograms) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        /*--------------------- ---------------------------- -----------------*/
        /*---------------------- Select All Nevada programs ------------------*/
        selectedAllNevadaPrograms() {
            let sum = 0

            this.units.forEach(item => {
                return item.State == "Nevada" ? sum++ : sum;
            })
            
            return this.program.length === sum
        },
        filterNevadaIcon() {
            if (this.selectedAllNevadaPrograms) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        /*--------------------- ---------------------------- -----------------*/
    },

    watch: {
        options: {
            handler() {
                this.getScheduleStaff();
            },
            deep: true,
        },
    },

    mounted() {
        this.getScheduleStaff();
    },

    methods: {

        ...mapMutations({
            setDateStart: "payroll/SET_DATE_START",
            setDateEnd: "payroll/SET_DATE_END",
        }),

        searchUnits(e) {
            console.log(e);
            //console.log(this.units);

            if (!this.searchTerm) {
                this.units = this.unitsCopy;
            } else {
                this.units = this.unitsCopy.filter((item) => {
                    return this.searchTerm.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
                });
            }
        },

        toggle() {
            this.$nextTick(() => {
                // if (this.likesAllUnits) {
                //     this.program = []
                // } else {
                //     this.program = this.units.slice()
                // }
                if (this.likesAllUnits) {
                    this.utahPrograms = []
                    this.nevadaPrograms = []
                    this.program = []
                } else {
                    this.program = this.units.slice()
                    this.program = this.program.map(item => item._id)
                }
            })
        },

        toggleUtahPrograms() {
            this.$nextTick(() => {
                if (this.selectedAllUtahPrograms) {
                    this.utahPrograms = []
                    this.program = []
                } else {
                    this.utahPrograms = this.units.filter(item => item.State == "Utah")
                    this.program = this.utahPrograms
                    this.program = this.program.map(item => item._id)
                }
            })
        },
        toggleNevadaPrograms() {
            this.$nextTick(() => {
                if (this.selectedAllNevadaPrograms) {
                    this.nevadaPrograms = []
                    this.program = []
                } else {
                    this.nevadaPrograms = this.units.filter(item => item.State == "Nevada")
                    this.program = this.nevadaPrograms
                    this.program = this.program.map(item => item._id)
                }
            })
        },

        programChange() {
            this.units = this.unitsCopy;
        },

        getUnits: async function () {
            await axios.get(`${url}/units`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item)
                })
            });

            this.unitsCopy = [...this.units];
        },

        getEmployees() {
            axios.get(`${url}/users/state/${this.state}`).then(res => {
                this.employees = res.data.users;
            });
        },

        getScheduleStaff() {

            this.isLoadingSchedule = true;

            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }
            this.schedules = [];

            const {page, itemsPerPage} = this.options;

            var req_body = {
                Program: this.program,
                Position: this.position,
                Employee: this.employee,
                DateStart: this.dateStart,
                DateEnd: this.dateEnd,
                GroupEmployee: this.radioGroup,
                Timezone: this.userTimezone,
                page: page,
                size: itemsPerPage

            };

            axios.post(`${url}/payroll/schedule`, req_body)
                .then(response => {
                    this.isLoadingSchedule = false;
                    this.totalData = response.data.total;
                    response.data.schedules.forEach((value) => {
                        value.StartDate = moment(new Date(value.StartDate)).format("YYYY-MM-DD hh:mm a");
                        value.EndDate = moment(new Date(value.EndDate)).format("YYYY-MM-DD hh:mm a");
                        value.TotalTime = value.TotalTime.toFixed(2);
                        value.program = this.findProgram(value.program)
                        this.schedules.push(value);
                    });
                })
                .catch(error => {
                    console.log({error});
                })
        },

        findProgram(programID) {
            return this.units.filter(unit => {
                if (unit._id === programID) return unit
            }).map(value => {
                return value.Name
            });
        },

    },

}
</script>
